import { useEffect, useId, useRef, type ReactNode } from 'react';
import { X } from 'lucide-react';

export function Modal({ title, description, onClose, children, wide = false }: { title: string; description?: string; onClose(): void; children: ReactNode; wide?: boolean }) {
  const dialog = useRef<HTMLDialogElement>(null);
  const titleID = useId(); const descriptionID = useId();
  useEffect(() => {
    const node = dialog.current;
    if (!node) return;
    node.showModal();
    const cancel = (event: Event) => { event.preventDefault(); onClose(); };
    node.addEventListener('cancel', cancel);
    return () => node.removeEventListener('cancel', cancel);
  }, [onClose]);
  return (
    <dialog ref={dialog} aria-labelledby={titleID} aria-describedby={description ? descriptionID : undefined} className={`modal ${wide ? 'modal-wide' : ''}`} onClick={(event) => { if (event.target === dialog.current) onClose(); }}>
      <div className="modal-card">
        <header className="modal-header">
          <div><h2 id={titleID}>{title}</h2>{description && <p id={descriptionID}>{description}</p>}</div>
          <button className="icon-button" type="button" onClick={onClose} aria-label="Schließen"><X /></button>
        </header>
        {children}
      </div>
    </dialog>
  );
}
